import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { SHOP_URL } from "../lib/assets";
import { SUPPORTED_LANGS } from "../i18n/translations";

const LANG_LABELS = { en: "EN", fr: "FR", es: "ES" };

export const Header = () => {
  const { lang, setLang, t } = useI18n();

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-30 border-b-2 border-[#ff0044] bg-[#050505]/95 backdrop-blur"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
        <a
          href="#top"
          data-testid="logo-link"
          className="flex items-center gap-3 group"
        >
          <span className="font-jp font-black text-[#00ffff] glow-cyan text-2xl sm:text-3xl leading-none">世界転生</span>
          <span className="hidden sm:inline font-pixel text-[#ffe600] glow-yellow text-xl tracking-[0.3em]">SEKAI TENSEI</span>
        </a>

        <div className="flex items-center gap-2 sm:gap-3">
          <div
            role="group"
            aria-label={t.nav.lang}
            data-testid="lang-switcher"
            className="hidden sm:flex items-center gap-1 mr-1"
          >
            <span className="font-pixel text-[#94a3b8] text-base mr-1 tracking-widest">{t.nav.lang}:</span>
            {SUPPORTED_LANGS.map((l) => (
              <button
                key={l}
                type="button"
                data-testid={`lang-btn-${l}`}
                onClick={() => setLang(l)}
                className={`btn-retro-ghost ${lang === l ? "is-active" : ""}`}
                aria-pressed={lang === l}
              >
                {LANG_LABELS[l]}
              </button>
            ))}
          </div>

          {/* Mobile lang select via plain native select to keep it lightweight */}
          <select
            data-testid="lang-select-mobile"
            value={lang}
            onChange={(e) => setLang(e.target.value)}
            className="sm:hidden font-pixel bg-black text-[#00ffff] border-2 border-[#00ffff]/60 rounded-none px-2 py-1 text-lg"
            aria-label={t.nav.lang}
          >
            {SUPPORTED_LANGS.map((l) => (
              <option key={l} value={l}>{LANG_LABELS[l]}</option>
            ))}
          </select>

          <a
            data-testid="shop-link"
            href={SHOP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-retro"
          >
            ▶ {t.nav.shop}
          </a>
        </div>
      </div>

      {/* Marquee */}
      <div className="border-t border-[#ff0044]/40 bg-black overflow-hidden">
        <div className="marquee-track whitespace-nowrap py-1.5 font-pixel text-[#2bff88] glow-green text-base">
          {Array.from({ length: 2 }).map((_, i) => (
            <span key={i} className="inline-block px-6">
              ★ SEKAI TENSEI 世界転生 ★ AMSTRAD GX4000 + CPC6128 PLUS ★ CARTRIDGE 256K ★ JOYSTICK READY ★ SEVEN WORLDS — SEVEN BOSSES ★ INSERT CARTRIDGE TO BEGIN ★ 1989-2026 ARCADE FOREVER ★ NOZORA VS KUROTENSHI ★&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
          ))}
        </div>
      </div>
    </header>
  );
};

export default Header;
